import script from "./moduleList.vue?vue&type=script&lang=ts&setup=true"
export * from "./moduleList.vue?vue&type=script&lang=ts&setup=true"

import "./moduleList.vue?vue&type=style&index=0&id=a83ee2d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a83ee2d8"]])

export default __exports__